import { axiosService } from "./axiosService";

const lotteryApi = {
    getAll() {
        const url = '/lottery';
        return axiosService.get(url)
    },
    create(body) {
        const url = '/lottery';
        return axiosService.post(url, body)
    },
    update(id, body) {
        const url = `/lottery/${id}`;
        return axiosService.put(url, body)
    },
    delete(id) {
        const url = `/lottery/${id}`;
        return axiosService.delete(url)
    },
}

export default lotteryApi;